import React, { useEffect } from "react";
import axios from "axios";
import TeamService from "services/TeamService";
import Loader from "components/Loader";
import { useTeamContext } from "store/contexts/teamContext";
import TeamMembersList from "components/TeamMembersList/TeamMembersList";
import TeamName from "components/TeamName";
import TeamAvatar from "components/TeamAvatar";
import TeamOptions from "components/TeamOptions";
import UserSlackInformation from "components/UserSlackInformation";
import { useGlobalContext } from "store/contexts/globalContext";
import { useTeamActionContext } from "store/contexts/teamActionContext";

export default () => {
  const { team, setTeam } = useTeamContext();
  const { teamId } = useTeamActionContext();
  const { microsoftConfigureTab } = useGlobalContext();
  const loaderStyle = {
    display: "flex",
    justifyContent: "center",
  };

  useEffect(() => {
    // get team members and profile
    let isMounted = true;

    try {
      (async () => {
        const [membersResponse, profileResponse] = await axios.all([
          TeamService.getMembers(teamId),
          TeamService.getTeamProfile(teamId),
        ]);

        if (isMounted) {
          setTeam({
            ...team,
            profile: profileResponse.data.data,
            members: membersResponse.data.data,
          });
        }
      })();
    } catch (error) {
      console.log(error);
    }

    return () => {
      isMounted = false;
    };

    // eslint-disable-next-line
  }, [teamId]);

  if (!team.profile || !team.members) {
    return (
      <div style={loaderStyle}>
        <Loader />
      </div>
    );
  }

  return (
    <div className="teaminfo-detail">
      <div className="teaminfo-header">
        <div className="row">
          <div className="col-xl-6 col-lg-12 col-md-6 col-sm-6">
            <div className="teaminfo-profile-left">
              <TeamAvatar team={team} setTeam={setTeam} />
              <TeamName team={team} setTeam={setTeam} />
            </div>
          </div>
          <div className="col-xl-6 col-lg-12 col-md-6  col-sm-6 d-flex va-center teaminfo-profile-right">
            <div className="p-h-right teamInformationRightOptions">
              <TeamOptions team={team} setTeam={setTeam} />
            </div>
          </div>
        </div>
      </div>
      {!microsoftConfigureTab && <UserSlackInformation team={team} />}
      <TeamMembersList />
    </div>
  );
};
